import HttpClient from '../httpClient';

export interface Workspace {
  orgId: string;
  workspaceId?: string;
  workspaceName: string;
  workspaceDescription?: unknown;
  workspaceLogo?: string;
  workspaceLogoUrl?: string;
  website?: string;
  industry?: string;
  companySize?: string;
  isClientCompany?: boolean;
  isOrgRoot?: boolean;
  [key: string]: unknown;
}

class WorkspaceController extends HttpClient {
  getAllWorkSpaces = async (orgId: string, token: string) => {
    const response = await this.client.get(`/getAllWorkspaces/${orgId}`, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  createWorkspace = async (payload: Workspace, token: string) => {
    const response = await this.client.post('/createWorkspace', payload, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };

  updateWorkspace = async (
    payload: {
      orgId: string;
      workspaceId: string;
      [key: string]: unknown;
    },
    token: string,
  ) => {
    const response = await this.client.put('/updateWorkspace', payload, {
      headers: {
        Authorization: token,
      },
    });
    return response.data;
  };
}

export default new WorkspaceController(
  process.env.REACT_APP_API_URL_ENTERPRISE,
);
